import fetch from '../utils/fetch';
import CustomError from '../utils/CustomError';
import {
  locationsEndpoint,
  getLocationsEndpointV3,
  installedProductsV4
} from '../constants/endpoints';
import {
  UNEXPECTED_ERROR,
  SEARCH_LOCATIONS_SUCCESS,
  CREATE_LOCATIONS_SUCCESS,
  TRANSACTION_ID,
  GET_LOCATION_ID_SUCCESS,
  UPDATE_LOCATION_ID_SUCCESS
} from '../constants/services';

export async function searchLocations(token, category, qname) {
  try {
    const params = qname ? { qname } : '';
    const query = await fetch(`${locationsEndpoint}/category/${category}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      params
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: SEARCH_LOCATIONS_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}
/**
 * getLocationsServ function to get locations with limit and pagination
 * * @param {string} token is a valid auth token for the endpoints
 * * @param {int} limit for pagination
 * * @param {string} pagToken pagination token
 * * @param {string} isNext to know is endpoint should return next or prev page
 * * @returns {object} returns endpoint response or throw endpoint error
 * */
export async function getLocationsServ(token, limit, pagToken, isNext) {
  try {
    const params = { limit, category: 'loadingfacility' };
    if (isNext === 'next') {
      params.nextPage = pagToken;
    } else if (isNext === 'prev') {
      params.previousPage = pagToken;
    }
    const query = await fetch(`${locationsEndpoint}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      params
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: SEARCH_LOCATIONS_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * getLocationIdServ function to get location by id
 * * @param {string} token is a valid auth token for the endpoints
 * * @param {string} id location id
 * * @returns {object} returns endpoint response or throw endpoint error
 * */
export async function getLocationIdServ(token, id) {
  try {
    const query = await fetch(`${locationsEndpoint}/${id}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      }
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: GET_LOCATION_ID_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export async function createLocations(token, data) {
  try {
    const query = await fetch(locationsEndpoint, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    const transactionId = query.headers.get(TRANSACTION_ID);
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: CREATE_LOCATIONS_SUCCESS,
      data: json.data
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * updatelocationServ function to update location by id
 * * @param {object} data location data
 * * @param {string} id location id
 * * @param {boolean} removeTurbinesOnEmpty whether to remove turbines on empty (default: false)
 * * @returns {object} returns endpoint response or throw endpoint error
 * */
export async function updatelocationServ(
  token,
  data,
  id,
  removeTurbinesOnEmpty = false
) {
  try {
    const params = {};
    if (removeTurbinesOnEmpty) {
      params.removeTurbinesOnEmpty = true;
    }
    const query = await fetch(`${locationsEndpoint}/${id}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data),
      params
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: UPDATE_LOCATION_ID_SUCCESS,
      data: json.data
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * deletelocationServ function to delete location by id
 * * @param {string} id location id
 * * @returns {object} returns endpoint response or throw endpoint error
 * */
export async function deletelocationServ(token, id) {
  try {
    const query = await fetch(`${locationsEndpoint}/${id}`, {
      method: 'delete',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      }
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: UPDATE_LOCATION_ID_SUCCESS,
      data: json.data
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}
/**
 * searchLocationsAdminServ function to search locations
 * * @param {string} token is a valid auth token for the endpoints
 * * @param {int} limit for pagination
 * * @param {string} pagToken pagination token
 * * @param {string} isNext to know is endpoint should return next or prev page
 * * @returns {object} returns endpoint response or throw endpoint error
 * */
export async function searchLocationsAdminServ(token, name) {
  try {
    const params = { name, category: 'loadingfacility' };
    const query = await fetch(`${locationsEndpoint}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      params
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: SEARCH_LOCATIONS_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * getLocationSFServ function to get location by Sales Force Record ID
 * * @param {string} token is a valid auth token for the endpoints
 * * @param {string} salesforceRecordId location id
 * * @returns {object} returns endpoint response or throw endpoint error
 * */
export async function getLocationSFServ(token, salesforceRecordId) {
  try {
    const params = { salesforceRecordId };
    const query = await fetch(`${locationsEndpoint}/category/wellsite`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      params
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: GET_LOCATION_ID_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * getLocationsV3Serv function to get locations using V3 endpoint with pagination
 * @param {string} token is a valid auth token for the endpoints
 * @param {object} params pagination parameters
 * @returns {object} returns endpoint response or throw endpoint error
 */
export async function getLocationsV3Serv(token, params = {}) {
  try {
    const { pageSize = 5, pageToken, pageNumber, method, companyId } = params;

    let url = `${getLocationsEndpointV3}?pageSize=${pageSize}`;

    if (method === 'token' && pageToken) {
      url += `&pageToken=${pageToken}`;
    } else if (method === 'pageNumber' && pageNumber) {
      url += `&pageNumber=${pageNumber}`;
    }

    if (companyId) {
      url += `&companyId=${companyId}`;
    }

    const query = await fetch(url, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      }
    });

    const transactionId = query.headers.get('transactionId');
    const json = await query.json();

    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }

    return {
      status: SEARCH_LOCATIONS_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export async function getLocationAccessLevelsServ(token, id) {
  try {
    const params = { withDetails: true };
    const query = await fetch(`${locationsEndpoint}/${id}/accessLevels`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      params
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: GET_LOCATION_ID_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export async function getLocationsWithAccessLevelsServ(token, username) {
  try {
    const params = username ? { user: username.toLowerCase() } : {};
    const query = await fetch(`${locationsEndpoint}/accessLevels`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      params
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: SEARCH_LOCATIONS_SUCCESS,
      data: json.data,
      info: json.info || json._meta
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * Gets unassigned turbines from the API
 * @param {string} token - Valid authentication token for the endpoint
 * @returns {Promise<{data: Array}>} Returns endpoint response with unassigned turbines data or throws endpoint error
 */
export async function getUnassignedTurbinesServ(token) {
  try {
    const query = await fetch(installedProductsV4, {
      method: 'get',
      params: {
        type: 'TURBINE',
        assigned: false
      },
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      }
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      data: json.data
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export async function deleteUserCompanyServ(token, id, idLocation) {
  try {
    const query = await fetch(
      `${locationsEndpoint}/${idLocation}/accessLevels/${id}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${token}`
        }
      }
    );
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: GET_LOCATION_ID_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * getPowerSitesServ function to get power sites from installed products
 * @param {string} token is a valid auth token for the endpoints
 * @returns {object} returns endpoint response or throw endpoint error
 */
export async function getPowerSitesServ(token) {
  try {
    const query = await fetch(`${installedProductsV4}/locations`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      }
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: SEARCH_LOCATIONS_SUCCESS,
      data: json.data,
      info: json.info,
      meta: json._meta
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * getInstalledProductsBySiteServ function to get installed products by site id
 * @param {string} token is a valid auth token for the endpoints
 * @param {string} siteId is the location/site id
 * @returns {object} returns endpoint response or throw endpoint error
 */
export async function getInstalledProductsBySiteServ(
  token,
  siteId,
  params = {}
) {
  try {
    const query = await fetch(`${installedProductsV4}/locations/${siteId}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      params: Object.keys(params).length ? params : undefined
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: SEARCH_LOCATIONS_SUCCESS,
      data: json.data,
      info: json.info,
      meta: json._meta
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * getDataPointsServ function to get data points catalog from installed products
 * @param {string} token is a valid auth token for the endpoints
 * @returns {object} returns endpoint response or throw endpoint error
 */
export async function getDataPointsServ(token) {
  try {
    const query = await fetch(`${installedProductsV4}/data-points`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      }
    });
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: SEARCH_LOCATIONS_SUCCESS,
      data: json.data,
      info: json.info,
      meta: json._meta
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  throw new CustomError(UNEXPECTED_ERROR);
}

/**
 * updateLocationAccessLevelsServ function to update location access levels (companies and users)
 * @param {string} token - Valid authentication token for the endpoint
 * @param {string} locationId - Location ID
 * @param {object} data - Payload with companies and users arrays
 * @param {Array<{id: string, name: string}>} data.companies - Array of companies to assign
 * @param {Array<{name: string, username: string}>} data.users - Array of users to assign
 * @returns {Promise<{status: string, data: any}>} Returns endpoint response or throws endpoint error
 */
export async function updateLocationAccessLevelsServ(token, locationId, data) {
  try {
    const query = await fetch(
      `${locationsEndpoint}/${locationId}/accessLevels`,
      {
        method: 'put',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      }
    );
    const transactionId = query.headers.get('transactionId');
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }
    return {
      status: UPDATE_LOCATION_ID_SUCCESS,
      data: json.data,
      info: json.info
    };
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
  }
  // log error
  throw new CustomError(UNEXPECTED_ERROR);
}

export default {
  searchLocations,
  createLocations,
  getLocationIdServ,
  updatelocationServ,
  deletelocationServ,
  searchLocationsAdminServ,
  getLocationSFServ,
  getLocationsServ,
  getLocationsV3Serv,
  getPowerSitesServ,
  getInstalledProductsBySiteServ,
  getDataPointsServ,
  updateLocationAccessLevelsServ
};
